
const server = {
    local: 'http://localhost:4000',
    remote: 'https://permisjonserver-production.up.railway.app'
}

export{
    server
}